import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { UserProvider } from "./components/context/user/UserContext";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";

// Import global styles
import "./styles/globals.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <UserProvider>
        <App />
      </UserProvider>
    </Provider>
  </BrowserRouter>
);
